import { componentsThemeMap } from '../componentsThemeMap.js';
import { SectionComponentLayout } from '../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../providers/AnalyticsProvider.js';
import { ErrorBoundary } from '../ui/ErrorBoundary.js';
import '../ui/RichText/index.js';
import { articleRichTextOptions } from '../ui/RichText/options/articleRichTextOptions.js';
import { Text } from '../ui/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { RichText } from '../ui/RichText/RichText.js';
function EditorialBodyCopy({
  style = 'default',
  title,
  text,
  hasSpacingTop,
  anchor,
  richTextOptions
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    background = _componentsThemeMap$s.background,
    foregroundInlineLink = _componentsThemeMap$s.foregroundInlineLink;
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "EditorialBodyCopy",
      children: /*#__PURE__*/jsxs(SectionComponentLayout, {
        as: "section",
        background: background,
        hasSpacingHorizontal: true,
        anchor: anchor,
        hasSpacingTop: hasSpacingTop,
        hasNonDefaultBackgroundSpacingVertical: true,
        children: [title && /*#__PURE__*/jsx(Text, {
          variant: "display2",
          color: foreground,
          children: title
        }), text && /*#__PURE__*/jsx(RichText, {
          content: text,
          richTextOptions: richTextOptions || articleRichTextOptions,
          color: foregroundSecondary,
          secondaryColor: foregroundSecondary,
          foregroundInlineLink: foregroundInlineLink
        })]
      })
    })
  });
}
export { EditorialBodyCopy };
//# sourceMappingURL=EditorialBodyCopy.js.map
